import { colorTheme } from './extendedColors';
import { spacingTheme } from './extendedSpacing';
import { radiiTheme } from './extendedRadii';
import { bordersTheme } from './extendedBorders';
import { textStyleTheme } from './extendedTextStyles';
import { buttonTheme } from './extendedButtons';
import { popoverTheme } from './extendedPopover';
import { shadowTheme } from './extendedShadows';
import { checkboxTheme, inputTheme, formStyles } from './extendedFormControls';

const theme = {
  colors: colorTheme,
  space: spacingTheme,
  radii: radiiTheme,
  shadows: shadowTheme,
  borders: bordersTheme,
  textStyles: textStyleTheme,
  components: {
    Button: buttonTheme,
    Input: inputTheme,
    Form: formStyles,
    Checkbox: checkboxTheme,
    Popover: popoverTheme
  },
  styles: {
    global: {
      '.cmx-form-input, .cmx-form-select': {
        appearance: 'none',
        background: '#fff',
        backgroundImage: 'none',
        border: '1px solid #bcc3ce',
        borderRadius: '3px',
        color: '#3b4351',
        display: 'block',
        fontSize: '14px',
        height: '1.8rem',
        lineHeight: '1.2rem',
        maxWidth: '100%',
        outline: 'none',
        padding: '0.25rem 0.4rem',
        position: 'relative',
        transition: 'background .2s,border .2s,box-shadow .2s,color .2s',
        width: '100%',
      },
      'textarea.cmx-form-input': {
        height: 'auto',
      },
      '.cmx-form-input:focus, .cmx-form-select:focus': {
        borderColor: '#5755d9',
        boxShadow: '0 0 0 .1rem rgba(87,85,217,.2)',
      },
      '.cmx-form-checkbox': {
        display: 'inline-block',
      },
    },
  },
};

export default theme;
